<template>
  <FilterPopper>
    <template #default="{ menuOpen }">
      <BaseFilterButton
        :name="'Platform Type'"
        :active="isActive"
        :tagValue="tagValue"
        :menuOpen="menuOpen"
      />
    </template>
    <template #popper>
      <div v-if="platformTypeList.length > 0" class="filter-settings scrollbar">
        <div v-for="(item, index) in platformTypeList" :key="`${item.value}-${index}`" class="filter-settings__row">
          <input
            :id="`platformTypeFilter-${item.value}-${index}`"
            v-model="selectedPlatformTypes"
            type="checkbox"
            :name="'selected-platform-types'"
            :value="item.value"
          >
          <label :for="`platformTypeFilter-${item.value}-${index}`">{{ item.key }}</label>
        </div>
      </div>
      <div v-else class="filter-settings">
        No platform types available.
      </div>
      <div class="filter-footer">
        <button class="button-text clear-button" @click="clearSelection">Clear Selection</button>
      </div>
    </template>
  </FilterPopper>
</template>

<script setup>
import { computed } from 'vue';
import FilterPopper from '@/components/FilterPopper.vue';
import BaseFilterButton from '@/components/BaseFilterButton.vue';

const props = defineProps({
  platformTypeList: {
    type: Array,
    default: () => [],
  },
  modelValue: {
    type: Array,
    default: () => [],
  },
});

const emit = defineEmits(['update:modelValue']);

const selectedPlatformTypes = computed({
  get() {
    return Array.isArray(props.modelValue) ? props.modelValue : [];
  },
  set(value) {
    emit('update:modelValue', Array.isArray(value) ? value : []);
  },
});

const isActive = computed(() => selectedPlatformTypes.value.length > 0);
const tagValue = computed(() => selectedPlatformTypes.value.length.toString());

const clearSelection = () => {
  emit('update:modelValue', []);
};
</script>

<style lang="scss" scoped>
.filter-settings {
  display: flex;
  flex-direction: column;
  padding: 8px;
  border-radius: inherit;
  gap: 6px;
  min-width: 320px;
  overflow: auto;

  &__row {
    display: flex;
    align-items: flex-start;
  }

  & input[type=checkbox] {
    margin-right: 12px;
    margin-top: 3px;
    flex-shrink: 0;
  }
}

.filter-footer {
  min-height: 38px;
  width: 100%;
  border-top: 1px solid rgba(140,140,140,0.375);
  padding: 8px;
  text-align: center;

  .clear-button {
    text-align: center;
    @include themify() {
      color: themed('color-danger');
    }
  }
}
</style>
